import axios from "axios";
import {useEffect, useState} from "react";
import {Button, Col, Modal, Row, Spinner, Form} from "react-bootstrap"
import {Icon} from 'semantic-ui-react';
import {selectUser} from "../../features/user/userSlice";
import DropdownInput from "./DropdownInput";
import {useSelector} from 'react-redux';
import {useForm} from "react-hook-form";
import Conversation from "./Conversation";
import ClosedIssueNotification from "./ClosedIssueNotification";
import XperHistory from "./XperHistory";
import { createAxiosInstance } from "../../utils/axios-instance";
import { useMsal } from "@azure/msal-react";

const RequestDetail = (props) => {
    const request = props.request;
    const [assignTo, setAssignTo] = useState('');
    const [assignToList, setAssignToList] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [showAssignResult, setShowAssignResult] = useState(false);
    const [showAssignErrorResult, setAssignErrorResult] = useState(false);
    const [showCloseRequestConfirmation, setShowCloseRequestConfirmation] = useState(false);
    const [selectedIssueCategory, setSelectedIssueCategory] = useState('');
    const {register, setValue} = useForm({});

    const { instance } = useMsal();
    const user = useSelector(selectUser);
    const isRequestClosed = () => {
        return request.closedDate ? true : false;
    }
    const submitAssignment = () => {
        setIsLoading(true);
        const ssoMediatorUserId = assignTo.split('/')[1];
        if (assignTo === ''){
            setIsLoading(false);
            setAssignErrorResult(true);
        } else {
            const axiosInstance = createAxiosInstance(instance);
            axiosInstance.patch(process.env.REACT_APP_API_ENDPOINT + 'compliance/request', {
                requestToken: request.requestToken,
                ssoMediatorUserId,
                status: 'ASSIGNED',
                updatedBy: user?.ssoUserId,
                issueCategory: selectedIssueCategory
            }).then(resp => {
                setIsLoading(false);
                setShowAssignResult(true);
                props.handleReload();
            });
        }
    }
    const closeRequest = () => {
        setIsLoading(true);
        const axiosInstance = createAxiosInstance(instance);
        axiosInstance.post(process.env.REACT_APP_API_ENDPOINT + 'essiloradmin/request/' + request.requestToken + '/close', {}).then(resp => {
            if (resp) {
                setIsLoading(false);
                setShowCloseRequestConfirmation(false);
                props.handleReload();
            }
        });
    }
    const handleCloseRequestConfirmation = (action) => {
        if (!!!action) setShowCloseRequestConfirmation(false);

        closeRequest();
    }
    const handleAssignResultClose = () => {
        setShowAssignResult(false);
    }

    const handleAssignErrorClose = () => {
        setAssignErrorResult(false);
    }

    useEffect(() => {
        if (request && request.ssoMediatorUserId && assignToList && assignToList.length > 0) {
            const {issueCategory, ssoMediatorUserId} = request;
            setSelectedIssueCategory(issueCategory);
            setAssignTo(`${issueCategory}/${ssoMediatorUserId}`);
            setValue('assignedTo', `${issueCategory}/${ssoMediatorUserId}`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [request, assignToList])
    useEffect(() => {
        setAssignToList(props.items);

    }, [props.items])
    return (<>
        {request && <>
            <Row>
                <Col>
                    <Form.Group className="mb-3">
                        <Form.Label column={"sm"}>First Name</Form.Label>
                        <Form.Control column={"sm"} placeholder="Disabled input" readOnly={true}
                                      value={request?.firstName || user?.firstName}/>
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group className="mb-3">
                        <Form.Label column={"sm"}>Last Name</Form.Label>
                        <Form.Control column={"sm"} placeholder="Disabled input" readOnly={true}
                                      value={request?.lastName || user?.lastName}/>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Group className="mb-3">
                        <Form.Label column={"sm"}>Email</Form.Label>
                        <Form.Control column={"sm"} placeholder="Disabled input" readOnly={true}
                                      value={request?.email || user?.email}/>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                {request?.practiceName && <Col>
                    <Form.Group className="mb-3">
                        <Form.Label column={"sm"}>Practice Name</Form.Label>
                        <Form.Control column={"sm"} placeholder="Disabled input" readOnly={true}
                                      value={request.practiceName || user?.practiceName}/>
                    </Form.Group>
                </Col>}
                {request?.salesRepName && <Col>
                    <Form.Group className="mb-3">
                        <Form.Label column={"sm"}>Sales Rep Name:</Form.Label>
                        <Form.Control column={"sm"} placeholder="Disabled input" readOnly={true}
                                      value={request.salesRepName || user?.salesRepName}/>
                    </Form.Group>
                </Col>}
            </Row>
            <Row>
                <Col>
                    <Form.Group className="mb-3">
                        <Form.Label column={"sm"}>Issue Category</Form.Label>
                        <Form.Control column={"sm"} placeholder="Disabled input" readOnly={true}
                                      value={selectedIssueCategory}/>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                {request.accountInfo && <Col>
                    <Form.Group className="mb-3">
                        <Form.Label column={"sm"}>Account Info</Form.Label>
                        <Form.Control column={"sm"} placeholder="Disabled input" readOnly={true}
                                      value={request?.accountInfo || user?.accountInfo}/>
                    </Form.Group>
                </Col>}
            </Row>

            <Row className="mt-10">
                {user ? (<Form.Group>
                    {!request.certFlag && <Form.Check
                        type='radio'
                        label='Certification for myself'
                        checked={!request.certFlag}
                        disabled
                    />}
                        {request.certOnBehalfOf && <Form.Check
                        type='radio'
                        label={'Certification on behalf of: ' + request.certOnBehalfOf}
                        checked={request.certFlag}
                        disabled
                    />}
                </Form.Group>) : (<p>
                    {request.certFlag ? 'Certification on behalf of: ' + request.certOnBehalfOf : ''}
                </p>)}
            </Row>

            <Row>
                {request.issueDesc && <Col>
                    <Form.Group className="mb-3">
                        <Form.Label column={"sm"}>Issue Description</Form.Label>
                        <Form.Control as="textarea" rows={5} column={"sm"} placeholder="Disabled input" readOnly={true}
                                      value={request.issueDesc || user?.issueDesc}/>
                    </Form.Group>
                </Col>}
            </Row>

            <Row>
                <Col>
                    <hr/>
                    <p className="h2">Messages</p>
                    <p>You and the specialist can communicate back and forth in the message box below. To initiate a message fill out the form below and click the send button / icon</p>
                    <Conversation request={request}/>
                    <hr/>
                </Col>
            </Row>

            {(user?.userRole === 'MEDIATOR' || user?.userRole === 'ESSILORADMIN') &&
              <>
                <Row>
                    <Col>
                        <p className="h2">Assigned To:</p>
                        <DropdownInput handleDropdownSelect={($event) => {
                            const val = $event.target.value;
                            const issueCategory = val.split('/')[0];
                            setSelectedIssueCategory(issueCategory);
                            setAssignTo(val);
                        }} register={register('assignedTo')}
                                      label={''} items={props.items}
                        ></DropdownInput>
                    </Col>
                </Row>
                <br/>
                <Row>
                    <Col>
                        <p className="h2">Assigned Xfer History:</p>
                        <XperHistory request={request} />
                    </Col>
                </Row>
              </>
            }
            <Row hidden={!isRequestClosed()}>
                <Col>
                    <ClosedIssueNotification/>
                </Col>
            </Row>
            <Row className="mt-20">
                <Col sm={user?.userRole === 'MEDIATOR' || user?.userRole === 'ESSILORADMIN' ? 4 : 6} className="d-grid">
                    <Button variant="info" disabled={isLoading} onClick={() => props.handleOpenAttachments(request.requestId)}><Icon
                        name="attach"/>View / Upload Attachment(s)</Button>
                </Col>

                {/* <Col sm={user?.userRole === 'MEDIATOR' || user?.userRole === 'ESSILORADMIN' ? 4 : 6} className="d-grid">
                    <Button variant="secondary" onClick={() => props.handleOpenDetails(request.requestId)}><Icon
                        name="info circle"/>Submit Message</Button>
                </Col> */}
                {(user?.userRole === 'MEDIATOR' || user?.userRole === 'ESSILORADMIN') && <Col sm={4} className="d-grid">
                    <Button variant="primary" hidden={isRequestClosed()} disabled={isLoading} onClick={submitAssignment}><Icon name="sign-out"/>
                        Submit Assignment
                        {isLoading && <Spinner animation="border" role="status" size="sm">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>}
                    </Button>
                </Col>}
                {(user?.userRole === 'MEDIATOR' || user?.userRole === 'ESSILORADMIN') && <Col sm={4} className="d-grid">
                    <Button variant="primary" hidden={isRequestClosed()} disabled={isLoading} onClick={()=>setShowCloseRequestConfirmation(true)}>
                        Close Issue / Request
                        {isLoading && <Spinner animation="border" role="status" size="sm">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>}
                    </Button>
                </Col>}
            </Row>
        </>}
        <Modal show={showCloseRequestConfirmation} onHide={handleCloseRequestConfirmation}>
            <Modal.Header closeButton>
                <Modal.Title>Do you want to close this issue/request?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="text-right">
                    <Col sm={2}>
                        <Button variant="primary"  disabled={isLoading} onClick={() => handleCloseRequestConfirmation('ACTION_YES')}>Yes</Button>
                    </Col>
                    <Col sm={2}>
                        <Button variant="secondary"  disabled={isLoading} onClick={() => handleCloseRequestConfirmation()}>No</Button>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
        <Modal show={showAssignResult} onHide={handleAssignResultClose}>
            <Modal.Header closeButton>
                <Modal.Title>Assign Complete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                The assignment to mediator is complete.
            </Modal.Body>
        </Modal>
        <Modal show={showAssignErrorResult} onHide={handleAssignErrorClose}>
            <Modal.Header closeButton>
                <Modal.Title>Assign Error</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                You appear to be assigning to the existing mediator/specialist.
                Please select a different mediator/specialist in the "assigned to:" section.
            </Modal.Body>
        </Modal>
    </>)
}

export default RequestDetail;
